import { Droplet } from 'lucide-react';
import { useEffect } from 'react';
import { XStack, YStack, Image } from 'tamagui';

import { SensorWidget } from './SensorWidget';
import {
  hvacIcon as hvacIconAsset,
  airIcon as airIconAsset,
  energyIcon as energyIconAsset,
} from '../../../assets';
// Temporarily commented out - using hardcoded healthy state
// import {
//   useWaterQualitySensorStatus,
//   useHVACSensorStatus,
//   useAirQualitySensorStatus,
//   useElectricalDeviceStatus,
// } from '../../../hooks';
// import { useCachedStatus } from '../../../hooks/status/useCachedStatus';
import { getIconColor, Status } from '../../../types/Status';

// Temporarily commented out - using hardcoded healthy state
// type SensorStatusType = 'default' | 'warning' | 'error';

// Temporarily commented out - hardcoding healthy state for all sensors
// const mapStatusToType = (status: string): SensorStatusType => {
//   switch (status?.toLowerCase()) {
//     case 'good':
//     case 'normal':
//     case 'ok':
//       return 'default';
//     case 'warning':
//     case 'caution':
//     case 'moderate':
//     case 'poor':
//       return 'warning';
//     case 'error':
//     case 'critical':
//     case 'bad':
//     case 'danger':
//       return 'error';
//     default:
//       return 'default';
//   }
// };

export const SensorGrid = () => {
  // Temporarily commented out - using hardcoded healthy state
  // const { data: waterStatus } = useCachedStatus('waterQuality', useWaterQualitySensorStatus);
  // const { data: hvacStatus } = useCachedStatus('hvac', useHVACSensorStatus);
  // const { data: airStatus } = useCachedStatus('airQuality', useAirQualitySensorStatus);
  // const electricalDeviceStatus = useElectricalDeviceStatus();

  useEffect(() => {
    const interval = setInterval(() => {}, 30000); // 30 seconds
    return () => clearInterval(interval);
  }, []);

  // const waterStatusType = mapStatusToType(waterStatus?.status || 'default');
  // const hvacStatusType = mapStatusToType(hvacStatus?.status || 'default');
  // const airStatusType = mapStatusToType(airStatus?.status || 'default');
  // const energyStatusType = mapStatusToType(electricalDeviceStatus.status || 'default');

  // const waterIconColor = getIconColor(waterStatus?.status || Status.Good);
  // const hvacIconColor = getIconColor(hvacStatus?.status || Status.Good);
  // const airIconColor = getIconColor(airStatus?.status || Status.Good);
  // const energyIconColor = getIconColor(electricalDeviceStatus?.status || Status.Good);

  // Temporary hardcode: Always show healthy state for all sensors
  const waterStatusType = 'default';
  const hvacStatusType = 'default';
  const airStatusType = 'default';
  const energyStatusType = 'default';

  const waterIconColor = getIconColor(Status.Good);
  const hvacIconColor = getIconColor(Status.Good);
  const airIconColor = getIconColor(Status.Good);
  const energyIconColor = getIconColor(Status.Good);

  const waterIconElement = <Droplet size={48} color={waterIconColor} />;
  const hvacIconElement = (
    <Image
      source={{ uri: hvacIconAsset }}
      width={48}
      height={48}
      alt="HVAC"
      tintColor={hvacIconColor}
    />
  );
  const airIconElement = (
    <Image
      source={{ uri: airIconAsset }}
      width={48}
      height={48}
      alt="Air"
      tintColor={airIconColor}
    />
  );
  const energyIconElement = (
    <Image
      source={{ uri: energyIconAsset }}
      width={48}
      height={48}
      alt="Energy"
      tintColor={energyIconColor}
    />
  );

  return (
    <YStack flexDirection="column" gap="$4">
      <XStack gap="$4">
        <SensorWidget action="Water" icon={waterIconElement} type={waterStatusType} />
        <SensorWidget action="HVAC" icon={hvacIconElement} type={hvacStatusType} />
      </XStack>
      <XStack gap="$4">
        <SensorWidget action="Air" icon={airIconElement} type={airStatusType} />
        <SensorWidget action="Power" icon={energyIconElement} type={energyStatusType} />
      </XStack>
    </YStack>
  );
};
